import AOS from 'aos';
import lozad from 'lozad';

AOS.init({
    duration: 500,
    easing: 'ease-out',
    delay: 100,
    once: true
});

const observer = lozad('.lozad', {
    rootMargin: '10px 0px', // syntax similar to that of CSS Margin
    threshold: 0.1, // ratio of element convergence
    enableAutoReload: true // it will reload the new image when validating attributes changes
});
observer.observe();

function setStickyHeader() {
    const pageHeader = document.querySelector('.page-header');
    if(!pageHeader) return;

    if(window.scrollY > 0) {
        pageHeader.classList.add('sticky');
    } else {
        pageHeader.classList.remove('sticky');
    }
}

window.addEventListener('scroll', () => {
    setStickyHeader();
});
